import { render, staticRenderFns } from "./ui-button.vue?vue&type=template&id=7e5f85ab&scoped=true&"
import script from "./ui-button.vue?vue&type=script&lang=ts&"
export * from "./ui-button.vue?vue&type=script&lang=ts&"
import style0 from "./ui-button.vue?vue&type=style&index=0&id=7e5f85ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5f85ab",
  null
  
)

export default component.exports